<template>
    <div class="row">

        <div class="col-lg-12">
            <div class="input-group">
                <input type="text" class="form-control" :value="displayValue" disabled>
                <span class="input-group-btn">
                    <button class="btn btn-primary" type="button" data-toggle="modal" data-target="#myModalPacpon">PACPON</button>
                </span>
            </div><!-- /input-group -->
        </div><!-- /.col-lg-6 -->

        <div class="modal fade" id="myModalPacpon" tabindex="-1" role="dialog" aria-hidden="true" aria-labelledby="myModalLabel">
            <div class="modal-dialog" role="document">
                <div class="modal-content">

                    <div class="modal-header">
                        <button type="button" class="close" onclick="$('#myModalPacpon').modal('hide')" data-dismiss="myModalLabel" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <h4 class="modal-title" id="myModalLabel">Caixas PacPon</h4>
                    </div>

                    <div class="modal-body">

                        <div class="row">
                            <div class="col-sm-10">
                                <label for="nome_pacpon" class="control-label">NOME DA CAIXA PACPON</label>
                                <input id="nome_pacpon" type="text" v-model="nome" class="form-control" >
                            </div>

                            <div class="col-md-2">
                                <label for="cto" class="control-label">CTO</label>
                                <select id="cto" v-model="cto" class="form-control">
                                    <option v-for="c in ctos" :value="c" v-bind:key="c">{{c}}</option>
                                </select>
                            </div>

                            <br />
                            <div style="margin-top: 12px" class="col-sm-12">
                                <ul class="list-group" style="height: 60vh; overflow-y: auto">
                                    <li class="list-group-item" v-for="c in getCaixas" v-bind:key="c._id">
                                        <button @click="displayValue = c" type="button" class="btn btn-primary btn-sm" data-dismiss="modal">ADICIONAR</button> &nbsp;&nbsp; {{c.nome}}
                                    </li>
                                </ul>
                            </div>
                        </div>

                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">
                            Cancelar
                        </button>
                    </div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { CaixaPacPon } from "../../class/caixa-pacpon";

export default {
    name: "filtro-pacpon",
    props: {
        value: {
            default: () => {}
        }
    },
    data() {
        return {
            caixas: [],
            cto: null,
            nome: null,
            ctos: []
        };
    },
    computed: {
        getCaixas: function() {
            if (!this.nome && !this.cto) {
                return this.caixas;
            }
            return this.caixas.filter(player => {
                if (this.cto && this.nome) {
                    return (
                        player.nome
                            .toLowerCase()
                            .includes(this.nome.toLowerCase()) &&
                        player.cto.numero === this.cto
                    );
                } else if (this.cto) {
                    return player.cto.numero === this.cto;
                } else if (this.nome) {
                    return player.nome
                        .toLowerCase()
                        .includes(this.nome.toLowerCase());
                }
            });
        },
        displayValue: {
            get: function() {
                if (!this.value) {
                    return null;
                }
                return this.value.nome;
            },
            set: function(modifiedValue) {
                this.$emit("input", modifiedValue);
            }
        }
    },
    beforeMount() {
        this.loadCaixas();
    },
    methods: {
        async loadCaixas() {
            this.caixas = await CaixaPacPon.all();
            this.caixas.forEach(c => {
                if (!this.ctos.includes(c.cto.numero)) {
                    this.ctos.push(c.cto.numero);
                }
            });
        }
    }
};
</script>
